import { render, staticRenderFns } from "./SaleAgentRequestListPage.vue?vue&type=template&id=05fa57c0&scoped=true"
import script from "./SaleAgentRequestListPage.vue?vue&type=script&lang=js"
export * from "./SaleAgentRequestListPage.vue?vue&type=script&lang=js"
import style0 from "./SaleAgentRequestListPage.vue?vue&type=style&index=0&id=05fa57c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa57c0",
  null
  
)

export default component.exports